import * as React from 'react';
import { Text } from 'react-native';
import TranslationViewModel from './TranslationViewModel';
import TranslationViewStyle from './TranslationViewStyle';
import { ContentView } from '@levelapp/softfabric';
export default class TranslationView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding Context
        this.bind(new TranslationViewModel(this), new TranslationViewStyle(this));
    }
    /* RENDER */
    render() {
        if (this.props.upperCase != undefined) {
            if (this.props.upperCase) {
                return (React.createElement(Text, { allowFontScaling: false, style: this.props.style }, this.binding.translate(this.props.children, true)));
            }
        }
        return (React.createElement(Text, { allowFontScaling: false, style: this.props.style }, this.binding.translate(this.props.children)));
    }
}
